import React, { Component, useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import FooterSection from "../component/layout/footer";
import FilterSearchSection from "../component/section/filtersearch";
import WidgetLikeSection from "../component/section/widgetlike";
import WidgetGroupSection from "../component/section/widgetgroup";
import AllPhotos from "../component/section/photos";
import GroupItemTwo from "../component/items/groupitemtwo";
import CommentModal from "../component/models/CommentModal";
import axios from "axios";
import { FiCheck, FiEdit } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { input } from "@testing-library/user-event/dist/cjs/event/input.js";
import { UserRoleOptions } from "../constants/userRole";
import { toast } from "react-toastify";
import { convertImageToWebP } from "../utils/convertToWebp";
import { SyncLoader } from "react-spinners";

const GroupPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  //   const userId = location.state?.userId;
  const groupId = location.state?.groupId;
  console.log("groyoId", groupId);

  //   alert(groupId);

  const userId = 2;
  const loggedInUserId = localStorage.getItem("user_id");
  const isOwnProfile = String(userId) === String(loggedInUserId);

  const [coverPreview, setCoverPreview] = useState(null);
  const [profilePreview, setProfilePreview] = useState(null);

  // handle friend and un friend status
  const [isMember, setIsMember] = useState(false);
  const token = localStorage.getItem("token");

  // for the show post
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const pageRef = useRef(1);
  const [postType, setPostType] = useState("all");
  const [hasMore, setHasMore] = useState(true);

  // for the friend list
  const [friends, setFriends] = useState([]);
  const [loadingFriends, setLoadingFriends] = useState(false);

  //   for the create post
  const [postText, setPostText] = useState("");
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);

  const [membersCount, setMembersCount] = useState("0");
  const [isMemeberGroup, setisMemeberGroup] = useState(false);
  //   handle image upload

  const [groupList, setGroupList] = useState([]);
  const [loadingGroups, setLoadingGroups] = useState(false);

  const [postToDelete, setPostToDelete] = useState(null);

  const [showCommentModal, setShowCommentModal] = useState(false);
  const [activeCommentPostId, setActiveCommentPostId] = useState(null);

  const openCommentModal = (e, postId) => {
    e.preventDefault();
    setActiveCommentPostId(postId);
    setShowCommentModal(true);
  };

  const handlePostImageUpload = async (e) => {
    const files = Array.from(e.target.files).slice(0, 2);
    for (let file of files) {
      const formData = new FormData();
      formData.append("image", file);

      try {
        setLoading(true);
        const res = await axios.post(
          `${process.env.REACT_APP_MAIN_SITE_URL}/upload-image`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        const imageUrl = res.data.data.url;
        setImages((prev) => [...prev, { url: imageUrl }].slice(0, 2));
      } catch (err) {
        console.error("Upload failed", err);
      }

      setLoading(false);
    }
  };

  const handleImageUpload = async (e, type = "cover") => {
    const file = e.target.files[0];
    if (!file) return;

    // Preview the original file (optional)
    const imageUrl = URL.createObjectURL(file);
    if (type === "cover") {
      setCoverPreview(imageUrl);
    } else {
      setProfilePreview(imageUrl);
    }

    try {
      const webpBlob = await convertImageToWebP(file);

      const form = new FormData();
      form.append("group_id", groupId);

      if (type === "cover") {
        form.append("cover_image", webpBlob, "cover_image.webp");
      } else {
        form.append("profile_image", webpBlob, "profile_image.webp");
      }

      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/profile-update`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      // Update UI
      if (type === "cover") {
        setUser((prev) => ({
          ...prev,
          coverImage: response.data.cover_image_url,
        }));
        setCoverPreview(null);
      } else {
        setUser((prev) => ({
          ...prev,
          profileImage: response.data.profile_image_url,
        }));
        setProfilePreview(null);
      }

      toast.success("Image uploaded successfully!");
    } catch (err) {
      console.error("Upload or conversion failed", err);
      toast.error("Image upload failed.");
    }
  };

  const removeImage = (index) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
  };

  const triggerFileInput = () => {
    fileInputRef.current.click();
  };

  const handleSubmit = async () => {
    if (!postText.trim() && images.length === 0) {
      alert("Post text or image is required.");
      return;
    }

    const payload = {
      body: postText,
      image_urls: images.map((img) => img.url),
      groupId: groupId,
    };

    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/post/store`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Post submitted successfully.");
      setPostText("");
      setImages([]);

      getPosts(true, postType);
    } catch (err) {
      console.error("Post failed", err);
    }
  };

  const getLatestGroups = async () => {
    axios
      .get(`${process.env.REACT_APP_MAIN_SITE_URL}/latest-groups`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setGroupList(res.data.data);

        console.log(res.data.data);
      })
      .catch((error) => {
        console.error("Failed to fetch top groups:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (!userId || !token) return;

    const fetchProfileAndFriendStatus = async () => {
      try {
        const [profileRes, groupRes] = await Promise.all([
          axios.get(`${process.env.REACT_APP_MAIN_SITE_URL}/group/${groupId}`, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(
            `${process.env.REACT_APP_MAIN_SITE_URL}/group/member-check/${groupId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          ),
        ]);

        const profileData = profileRes.data || {};

        setFormData({
          name: profileData.name || "",
          title: profileData.title || "",

          //   lookingFor: profileData.lookingFor || "",
          //   status: profileData.status || "",
          //   age: profileData.age || "",
          //   address: profileData.address || "",
        });

        setMembersCount(profileData.membersCount || "0");
        setisMemeberGroup(profileData.isMemberGroup);

        setUser({
          ...profileData,
          profileImage: profileData.img,
          coverImage: profileData.cover_image_url,
        });

        setIsMember(!!groupRes.data.status);
      } catch (err) {
        console.error("Error fetching profile or friend status", err);
        setError("Failed to load user");
      } finally {
        setLoading(false);
      }
    };

    fetchProfileAndFriendStatus();
    getLatestGroups();

    getPosts(true, "my");
  }, [userId, token]);

  // const handleMember = () => {
  //   axios
  //     .post(
  //       `${process.env.REACT_APP_MAIN_SITE_URL}/group/join-member`,
  //       { group_id: groupId },

  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log("responsedata", res.data);
  //       setIsMember(res.data.member === "1" || res.data.member === true);
  //     })
  //     .catch((err) => {
  //       console.error("Toggle friend error", err);
  //     });
  // };

  const handleMember = async () => {
    try {
      setLoading(true); // start loader

      const res = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/join-member`,
        { group_id: groupId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("responsedata", res.data);

      // Update membership state
      const memberStatus = res.data.member === "1" || res.data.member === true;
      setIsMember(memberStatus);

      // Show toast messages
      if (memberStatus) {
        toast.success("Successfully joined the group!");
      } else {
        toast.info("You are Exit from this group.");
      }
    } catch (err) {
      console.error("Toggle member error", err);
      toast.error("Failed to join the group. Please try again.");
    } finally {
      setLoading(false); // stop loader
    }
  };

  const [isEditing, setIsEditing] = useState(false);

  const toggleEdit = () => {
    if (isEditing) {
      updateGroup();
    }
    setIsEditing(!isEditing);
  };

  const [formData, setFormData] = useState({
    name: "N/A",
    title: "N/A",
  });

  const updateGroup = async () => {
    try {
      const token = localStorage.getItem("token");

      const response = await axios.put(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/update/${groupId}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Group updated successfully:", response.data);
    } catch (error) {
      console.error("Error updating group:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleImageUpload = async (e, type = "cover") => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   // Preview image immediately
  //   const imageUrl = URL.createObjectURL(file);
  //   if (type === "cover") {
  //     setCoverPreview(imageUrl);
  //   } else {
  //     setProfilePreview(imageUrl);
  //   }

  //   const form = new FormData();
  //   form.append("group_id", groupId);

  //   if (type === "cover") form.append("cover_image", file);
  //   else form.append("profile_image", file);

  //   try {
  //     const token = localStorage.getItem("token");
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_MAIN_SITE_URL}/group/profile-update`,
  //       form,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );

  //     if (type === "cover") {
  //       setUser((prev) => ({
  //         ...prev,
  //         coverImage: response.data.cover_image_url,
  //       }));
  //       setCoverPreview(null);
  //     } else {
  //       setUser((prev) => ({
  //         ...prev,
  //         profileImage: response.data.profile_image_url,
  //       }));
  //       setProfilePreview(null);
  //     }

  //     toast.success("Image uploaded successfully!");

  //   } catch (err) {
  //     console.error("Upload failed", err);
  //   }
  // };

  // for fetch post

  const handleTabChange = (type) => {
    setPostType(type);
    setPage(1);
    pageRef.current = 1;
    getPosts(true, type);
  };

  const [loadingMore, setLoadingMore] = useState(false);
  const observer = useRef();
  const getPostsRef = useRef();
  const hasMoreRef = useRef(hasMore);
  const loadingMoreRef = useRef(loadingMore);

  useEffect(() => {
    getPostsRef.current = getPosts;
  });

  useEffect(() => {
    hasMoreRef.current = hasMore;
  }, [hasMore]);

  useEffect(() => {
    loadingMoreRef.current = loadingMore;
  }, [loadingMore]);
  
  const lastElementRef = React.useCallback((node) => {
    if (loadingMore || !node) return;
    if (!observer.current) {
      observer.current = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && hasMoreRef.current && !loadingMoreRef.current) {
            if (getPostsRef.current) getPostsRef.current();
          }
        });
      });
    }
    observer.current.observe(node);
  }, [loadingMore]);

  const getPosts = async (reset = false, type = postType) => {
    if (!reset && loadingMoreRef.current) return;
    if (!reset) {
      setLoadingMore(true);
      loadingMoreRef.current = true;
    }
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/post`,
        {
          page: reset ? 1 : pageRef.current,
          type: type,
          groupId: groupId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      const newPosts = res.data.data.posts.data;

      setPosts((prev) => {
        if (reset) return newPosts;
        const unique = [...prev, ...newPosts].filter(
          (v, i, a) => a.findIndex((t) => t.id === v.id) === i
        );
        return unique;
      });

      if (!res.data.data.has_plan) {
        setHasMore(false);
      } else {
        setHasMore(res.data.data.posts.next_page_url !== null);
      }

      const nextPage = reset ? 2 : pageRef.current + 1;
      setPage(nextPage);
      pageRef.current = nextPage;
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      if (!reset) {
        setLoadingMore(false);
        loadingMoreRef.current = false;
      }
    }
  };

  // for fetch friends
  const fetchFriends = async () => {
    try {
      setLoadingFriends(true);
      const res = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/group/members-list`,
        { groupId },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setFriends(res.data);
    } catch (err) {
      console.error("Error fetching friends:", err);
    } finally {
      setLoadingFriends(false);
    }
  };

  const handleDeletePost = async (postId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_MAIN_SITE_URL}/post/delete/${postId}`,
        {}, // empty body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        toast.success("Post deleted successfully!");
        setPosts(posts.filter((post) => post.id !== postId));
      } else {
        toast.error(response.data.message || "Failed to delete post");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to delete post");
      console.error("Delete failed", err);
    }
  };

  const confirmDelete = () => {
    handleDeletePost(postToDelete);
    setPostToDelete(null);
  };

  const cancelDelete = () => {
    setPostToDelete(null);
  };

  if (loading)
    return (
      <div className="fullscreen-loader">
        <SyncLoader size={12} color="#DF314D" />
      </div>
    );
  if (error) return <div style={{ color: "red" }}>{error}</div>;

  return (
    <div>
      <Header />
      <PageHeader title={"Profile Single"} />

      {loading && (
        <div className="fullscreen-loader">
          <SyncLoader size={12} color="#DF314D" />
        </div>
      )}

      <section className="profile-section padding-tb">
        <div className="container">
          <div className="section-wrapper">
            <div className="member-profile">
              <div className="profile-item">
                <div className="profile-cover">
                  <img
                    src={
                      coverPreview ||
                      user?.coverImage ||
                      "/assets/images/profile/cover.jpg"
                    }
                    alt="cover"
                  />

                  {isOwnProfile && (
                    <div className="edit-photo custom-upload">
                      <div className="file-btn">
                        <i className="icofont-camera"></i> Edit Photo
                      </div>

                      <input
                        type="file"
                        accept="image/*"
                        // onChange={(e) => handleImageUpload(e, "cover")}
                      />
                    </div>
                  )}
                </div>

                <div className="profile-information">
                  <div className="profile-pic">
                    <img
                      src={
                        profilePreview ||
                        user?.profileImage ||
                        "/assets/images/profile/Profile.jpg"
                      }
                      alt="profile"
                    />{" "}
                    {isMemeberGroup && (
                      <div className="custom-upload">
                        <div className="file-btn">
                          <span className="d-none d-lg-inline-block">
                            {" "}
                            <i className="icofont-camera"></i>
                            Edit
                          </span>
                          <span className="d-lg-none mr-0">
                            <i className="icofont-plus"></i>
                          </span>
                        </div>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={(e) => handleImageUpload(e, "profile")}
                        />
                      </div>
                    )}
                  </div>

                  <div className="profile-name">
                    <h4>{user?.name}</h4>
                    <p>Active 02 Minutes Ago</p>
                  </div>
                  <ul className="profile-contact">
                    <li onClick={handleMember} style={{ cursor: "pointer" }}>
                      <a>
                        <div className="icon">
                          <i className="icofont-user"></i>
                        </div>
                        <div className="text">
                          <p>{isMember ? "Exit Group" : "Join Group"}</p>
                        </div>
                      </a>
                    </li>

                    <li>
                      <a href="#">
                        <div className="icon">
                          <i className="icofont-envelope"></i>
                        </div>
                        <div className="text">
                          {user && (
                            <Link
                              to="/chat"
                              state={{
                                type: "group",
                                id: user.id,
                                name: user.name,
                              }}
                            >
                              <p>Private Message</p>
                            </Link>
                          )}
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="profile-item d-none">
                <div className="lab-inner">
                  <div className="lab-thumb">
                    <a href="#">
                      <img
                        src="assets/images/profile/Profile.jpg"
                        alt="profile"
                      />
                    </a>
                  </div>

                  <div className="lab-content">
                    <div className="profile-name">
                      <div className="p-name-content">
                        <h4>William Smith</h4>
                        <p>Active 02 Minutes Ago</p>
                      </div>

                      <div className="contact-button">
                        <button className="contact-btn">
                          <i className="icofont-info-circle"></i>
                        </button>
                      </div>
                    </div>
                    <ul className="profile-contact">
                      <li>
                        <a href="#">
                          <div className="icon">
                            <i className="icofont-user"></i>
                          </div>
                          <div className="text">
                            <p>Add Friends</p>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <div className="icon">
                            <i className="icofont-envelope"></i>
                          </div>
                          <div className="text">
                            <p>Publice Message</p>
                          </div>
                        </a>
                      </li>
                      <li>
                        <a href="#">
                          <div className="icon">
                            <i className="icofont-envelope"></i>
                          </div>
                          <div className="text">
                            <p>Private Message</p>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="profile-details">
                <nav className="profile-nav">
                  <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      className="nav-link active"
                      id="nav-ativity-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#activity"
                      type="button"
                      role="tab"
                      aria-controls="activity"
                      aria-selected="true"
                    >
                      Posts
                    </button>
                    <button
                      className="nav-link"
                      id="nav-profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                    >
                      Profile
                    </button>
                    <button
                      className="nav-link"
                      id="nav-friends-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#friends"
                      type="button"
                      role="tab"
                      aria-controls="friends"
                      aria-selected="false"
                      onClick={fetchFriends}
                    >
                      Members{" "}
                      <span className="item-number">{membersCount}</span>
                    </button>

                    {/* for group sections  */}
                    {/* <button
                      className="nav-link"
                      id="nav-groups-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#groups"
                      type="button"
                      role="tab"
                      aria-controls="groups"
                      aria-selected="false"
                    >
                      Groups <span className="item-number">06</span>
                    </button> */}
                    <button
                      className="nav-link"
                      id="nav-photos-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#photos"
                      type="button"
                      role="tab"
                      aria-controls="photos"
                      aria-selected="false"
                    >
                      Photos
                    </button>
                    {/* <button
                      className="nav-link"
                      id="nav-media-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#media"
                      type="button"
                      role="tab"
                      aria-controls="media"
                      aria-selected="false"
                    >
                      Media <span className="item-number">35</span>
                    </button> */}
                    <div className="dropdown">
                      <a
                        className="btn dropdown-toggle"
                        href="#"
                        role="button"
                        id="dropdownMenuLink"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        More
                      </a>

                      <ul
                        className="dropdown-menu"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <li>
                          <a className="dropdown-item" href="#">
                            Activity
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Privacy
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item" href="#">
                            Block user
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </nav>
                <div className="tab-content" id="nav-tabContent">
                  <div
                    className="tab-pane activity-page fade show active"
                    id="activity"
                    role="tabpanel"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="activity-tab">
                              <ul
                                className="nav nav-pills mb-3"
                                id="pills-tab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="pills-mentions-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-mentions"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-mentions"
                                    aria-selected="true"
                                    onClick={() => handleTabChange("my")}
                                  >
                                    <i className="icofont-edit me-1"></i>
                                    Personal
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="pills-friends-tab"
                                    data-bs-toggle="pill"
                                    data-bs-target="#pills-friends"
                                    type="button"
                                    role="tab"
                                    aria-controls="pills-friends"
                                    aria-selected="false"
                                    onClick={() => handleTabChange("friends")}
                                  >
                                    <i className="icofont-heart-alt me-1"></i>
                                    Members Post
                                  </button>
                                </li>

                                <li className="custom-select">
                                  <select>
                                    <option value="1">Everything</option>
                                    <option value="2">Recent</option>
                                    <option value="3">Relevant</option>
                                    <option value="4">Popular</option>
                                  </select>
                                </li>
                              </ul>

                              <div
                                className="tab-content activity-content"
                                id="pills-tabContent"
                              >
                                <div
                                  className="tab-pane fade"
                                  id="pills-personal"
                                  role="tabpanel"
                                  aria-labelledby="pills-personal-tab"
                                >
                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>

                                <div
                                  className="tab-pane fade mentions-section show active"
                                  id="pills-mentions"
                                  role="tabpanel"
                                  aria-labelledby="pills-mentions-tab"
                                >
                                  <div className="create-post mb-20">
                                    <div className="lab-inner">
                                      <div className="lab-thumb">
                                        <div className="thumb-inner">
                                          <div
                                            style={{
                                              width: "12vw",
                                              height: "12vw",
                                              maxWidth: "50px",
                                              maxHeight: "50px",
                                              minWidth: "35px",
                                              minHeight: "35px",
                                              borderRadius: "50%",
                                              overflow: "hidden",
                                              display: "flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                            }}
                                            className="me-2"
                                          >
                                            <img
                                              src="assets/images/profile/dp2.png"
                                              alt="profile"
                                              style={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                              }}
                                            />
                                          </div>

                                          <div className="thumb-content">
                                            <h6>
                                          </h6>


                                            <div className="custom-select">
                                              
                                              <select>
                                                <option value="1">
                                                  &#xf02c; Public
                                                </option>
                                                <option value="2">
                                                  &#xec61; Private
                                                </option>
                                                <option value="3">
                                                  &#xed0d; Friends
                                                </option>
                                              </select>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="lab-content">
                                        <form className="post-form">
                                          <input
                                            type="text"
                                            placeholder="Whats on your mind. ?"
                                            value={postText}
                                            onChange={(e) =>
                                              setPostText(e.target.value)
                                            }
                                          />

                                          {images.length > 0 && (
                                            <div className="post-description">
                                              <div className="post-desc-img">
                                                <div className="row g-3">
                                                  {images.map(
                                                    (image, index) => (
                                                      <div
                                                        className="col-md-6"
                                                        key={index}
                                                      >
                                                        <div
                                                          className="image-wrapper"
                                                          style={{
                                                            position:
                                                              "relative",
                                                          }}
                                                        >
                                                          <img
                                                            src={image.url}
                                                            alt="upload preview"
                                                            className="w-100"
                                                          />
                                                          <button
                                                            type="button"
                                                            className="remove-image-btn"
                                                            onClick={() =>
                                                              removeImage(index)
                                                            }
                                                            title="Remove"
                                                          >
                                                            ×
                                                          </button>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          )}

                                          <div className="content-type">
                                            <ul className="content-list">
                                              <li className="text">
                                                <a href="#">
                                                  <i className="icofont-edit"></i>
                                                  Text
                                                </a>
                                              </li>
                                              <li className="image-video">
                                                <div
                                                  className="file-btn"
                                                  onClick={triggerFileInput}
                                                >
                                                  <i className="icofont-camera"></i>{" "}
                                                  Photo/Videos
                                                </div>
                                                <input
                                                  ref={fileInputRef}
                                                  type="file"
                                                  style={{ display: "none" }}
                                                  accept="image/*"
                                                  onChange={
                                                    handlePostImageUpload
                                                  }
                                                  multiple
                                                />
                                              </li>
                                              <li className="attach-file">
                                                <div className="file-btn">
                                                  <i className="icofont-paper-clip"></i>
                                                  Attach File
                                                </div>
                                                <input type="file" />
                                              </li>
                                              <li className="post-submit">
                                                <input
                                                  type="button"
                                                  value="Post"
                                                  className="lab-btn"
                                                  onClick={handleSubmit}
                                                />
                                              </li>
                                            </ul>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>

                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.avatar ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                alt="img"
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <a href="#">
                                                  {post.user?.name}
                                                </a>
                                              </h6>
                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}

                                  {/* <div className="post-item mb-20">
                                    <div className="post-content">
                                      <div className="post-author">
                                        <div className="post-author-inner">
                                          <div className="author-thumb">
                                            <img
                                              src="assets/images/profile/dp.png"
                                              alt="img"
                                            />
                                          </div>
                                          <div className="author-details">
                                            <h6>
                                              <a href="#">William Smith</a>
                                            </h6>
                                            <ul className="post-status">
                                              <li className="post-privacy">
                                                <i className="icofont-world"></i>
                                                Public
                                              </li>
                                              <li className="post-time">
                                                6 Mintues Ago
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="post-description">
                                        <p>
                                          Quickly deliver going forward methods
                                          info create empowerment before
                                          client-centered bandwdth Credibly
                                          pontficate interoperable leadership
                                          skills ands B2B data awesome
                                          Continually whiteboard ands B2B data
                                          awesome Continually whiteboard
                                        </p>
                                        <div className="post-desc-img">
                                          <div className="row g-3">
                                            <div className="col-md-6">
                                              <img
                                                src="assets/images/profile/post-image/02.jpg"
                                                alt="img"
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <img
                                                src="assets/images/profile/post-image/03.jpg"
                                                alt="img"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="post-meta">
                                      <div className="post-meta-top">
                                        <p>
                                          <a href="#">
                                            <i className="icofont-like"></i>{" "}
                                            <i className="icofont-heart"></i>{" "}
                                            <i className="icofont-laughing"></i>
                                            <span>
                                              Julia, Petrova and 306 like this
                                            </span>
                                          </a>
                                        </p>
                                        <p>
                                          <a href="#">136 Comments</a>
                                        </p>
                                      </div>
                                      <div className="post-meta-bottom">
                                        <ul className="react-list">
                                          <li className="react">
                                            <a href="#">
                                              <i className="icofont-like"></i>
                                              Like
                                            </a>{" "}
                                          </li>
                                          <li className="react">
                                            <a href="#" onClick={(e) => { e.preventDefault(); }}>
                                              <i className="icofont-speech-comments"></i>
                                              Comment
                                            </a>
                                          </li>
                                          <li className="react">
                                            <a href="#">
                                              <i className="icofont-share"></i>{" "}
                                              Share
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </div> */}

                                  {/* 
                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )} */}
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="pills-friends"
                                  role="tabpanel"
                                  aria-labelledby="pills-friends-tab"
                                >
                                  {posts.map((post) => (
                                    <div
                                      className="post-item mb-20"
                                      key={post.id}
                                    >
                                      <div className="post-content">
                                        <div className="post-author">
                                          <div className="post-author-inner">
                                            <div className="author-thumb">
                                              <img
                                                src={
                                                  post.user?.avatar ||
                                                  "assets/images/profile/dp.png"
                                                }
                                                alt="img"
                                              />
                                            </div>
                                            <div className="author-details">
                                              <h6>
                                                <a href="#">
                                                  {post.user?.name}
                                                </a>
                                              </h6>
                                              <ul className="post-status">
                                                <li className="post-privacy">
                                                  <i className="icofont-world"></i>{" "}
                                                  Public
                                                </li>
                                                <li className="post-time">
                                                  {post.time_ago}
                                                </li>
                                              </ul>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="post-description">
                                          <p>{post.body}</p>
                                          {post.image_urls?.length > 0 && (
                                            <div className="post-desc-img">
                                              <div className="row g-3">
                                                {post.image_urls.map(
                                                  (img, idx) => (
                                                    <div
                                                      className={
                                                        post.image_urls
                                                          .length === 2
                                                          ? "col-md-6"
                                                          : "col-md-12"
                                                      }
                                                      key={idx}
                                                    >
                                                      <img
                                                        src={img}
                                                        alt="post"
                                                        className="w-100"
                                                      />
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                      <div className="post-meta">
                                        <div className="post-meta-top">
                                          <p>
                                            <a href="#">
                                              <i className="icofont-like"></i>{" "}
                                              <i className="icofont-heart"></i>{" "}
                                              <span>Liked by others</span>
                                            </a>
                                          </p>
                                          <p>
                                            <a href="#">Comments</a>
                                          </p>
                                        </div>
                                        <div className="post-meta-bottom">
                                          <ul className="react-list">
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-like"></i>{" "}
                                                Like
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#" onClick={(e) => openCommentModal(e, post.id)}>
                                                <i className="icofont-speech-comments"></i>{" "}
                                                Comment
                                              </a>
                                            </li>
                                            <li className="react">
                                              <a href="#">
                                                <i className="icofont-share"></i>{" "}
                                                Share
                                              </a>
                                            </li>
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  ))}

                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="pills-groups"
                                  role="tabpanel"
                                  aria-labelledby="pills-groups-tab"
                                >
                                  {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            <WidgetGroupSection
                              groupList={groupList}
                              loading={loadingGroups}
                            />{" "}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="nav-profile-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="info-card mb-20">
                              <div className="info-card-title d-flex justify-content-between">
                                <h6>Base Info</h6>

                                <div className="display-flex flex-row gap-4">
                                  {isMemeberGroup &&
                                    (isEditing ? (
                                      <p
                                        onClick={toggleEdit}
                                        style={{ cursor: "pointer" }}
                                      >
                                        Save
                                      </p>
                                    ) : (
                                      <FiEdit
                                        title="Edit"
                                        onClick={toggleEdit}
                                        style={{ cursor: "pointer" }}
                                      />
                                    ))}
                                </div>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">Name</p>
                                    {isEditing ? (
                                      <input
                                        type="text"
                                        name="name"
                                        className="text-black"
                                        value={formData.name}
                                        onChange={handleChange}
                                      />
                                    ) : (
                                      <p className="info-details">
                                        {formData.name}
                                      </p>
                                    )}
                                  </li>
                                  <li>
                                    <p className="info-name">About Group</p>
                                    {isEditing ? (
                                      <input
                                        type="text"
                                        name="title"
                                        className="text-black"
                                        value={formData.title}
                                        onChange={handleChange}
                                      />
                                    ) : (
                                      <p className="info-details">
                                        {formData.title}
                                      </p>
                                    )}
                                  </li>
                                </ul>
                              </div>
                            </div>

                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Myself Summary</h6>
                              </div>
                              <div className="info-card-content">
                                <p>
                                  Collaboratively innovate compelling mindshare
                                  after prospective partnerships Competently
                                  sereiz long-term high-impact internal or
                                  "organic" sources via user friendly strategic
                                  themesr areas creat Dramatically coordinate
                                  premium partnerships rather than standards
                                  compliant technologies ernd Dramatically
                                  matrix ethical collaboration and idea-sharing
                                  through opensource methodologies and
                                  Intrinsicly grow collaborative platforms
                                  vis-a-vis effective scenarios. Energistically
                                  strategize cost effective ideas before the
                                  worke unde.
                                </p>
                              </div>
                            </div>

                            <div className="info-card mb-20">
                              <div className="info-card-title">
                                <h6>Looking For</h6>
                              </div>
                              <div className="info-card-content">
                                <ul className="info-list">
                                  <li>
                                    <p className="info-name">
                                      Things I'm looking for
                                    </p>
                                    <p className="info-details">
                                      I want a funny person
                                    </p>
                                  </li>
                                  <li>
                                    <p className="info-name">Whatever I like</p>
                                    <p className="info-details">
                                      I like to travel a lot
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="friends"
                    role="tabpanel"
                    aria-labelledby="nav-friends-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="row g-3 row-cols-2 row-cols-md-3 row-cols-lg-4 row-cols-xl-5 justify-content-center">
                              {/* <div className=" col-lg-3 col-md-4 col-6">
                                <div className="lab-item member-item style-1">
                                  <div className="lab-inner">
                                    <div className="lab-thumb">
                                      <img
                                        src="assets/images/member/01.jpg"
                                        alt="member-img"
                                      />
                                    </div>
                                    <div className="lab-content">
                                      <h6>
                                        <Link to="/profile">jenifer Guido</Link>{" "}
                                      </h6>
                                      <p>Active 1 Day</p>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {friends && friends.length > 0 ? (
                                friends.map((friend) => (
                                  <Link
                                    to="/profile"
                                    state={{ userId: friend.id }}
                                  >
                                    <div
                                      className="col member-item-card"
                                      key={friend.id}
                                    >
                                      <div className="lab-item member-item style-1 style-2">
                                        <div className="lab-inner">
                                          <div className="lab-thumb">
                                            <img
                                              src={
                                                friend.imgUrl ||
                                                "/assets/images/member/01.jpg"
                                              }
                                              alt={
                                                friend.imgAlt || "member-img"
                                              }
                                            />
                                          </div>
                                          <div className="lab-content">
                                            <h6>
                                              <Link
                                                to="/profile"
                                                state={{ userId: friend.id }}
                                              >
                                                {friend.memName}
                                              </Link>
                                            </h6>
                                            <p>
                                              {friend.memActive ||
                                                "Active 1 Day"}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                ))
                              ) : (
                                <div className="col-12">
                                  <p>No friends found.</p>
                                </div>
                              )}
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="tab-pane fade"
                    id="groups"
                    role="tabpanel"
                    aria-labelledby="nav-groups-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="row gy-3">
                              <GroupItemTwo itemNumber={4} />
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="photos"
                    role="tabpanel"
                    aria-labelledby="nav-photos-tab"
                  >
                    <AllPhotos />
                  </div>
                  <div
                    className="tab-pane fade"
                    id="media"
                    role="tabpanel"
                    aria-labelledby="nav-media-tab"
                  >
                    <div>
                      <div className="row">
                        <div className="col-xl-8">
                          <article>
                            <div className="media-wrapper">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link active"
                                    id="all-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#all-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="all-media"
                                    aria-selected="true"
                                  >
                                    <i className="icofont-star"></i> All Media
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="album-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#album"
                                    type="button"
                                    role="tab"
                                    aria-controls="album"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-layout"></i> Albums
                                    <span>04</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="photos-media-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#photos-media"
                                    type="button"
                                    role="tab"
                                    aria-controls="photos-media"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-image"></i>
                                    Photos <span>12</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="video-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#video"
                                    type="button"
                                    role="tab"
                                    aria-controls="video"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-video-alt"></i> Videos
                                    <span>0</span>
                                  </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                  <button
                                    className="nav-link"
                                    id="music-tab"
                                    data-bs-toggle="tab"
                                    data-bs-target="#music"
                                    type="button"
                                    role="tab"
                                    aria-controls="music"
                                    aria-selected="false"
                                  >
                                    <i className="icofont-music-disk"></i> Music
                                    <span>0</span>
                                  </button>
                                </li>
                              </ul>
                              <div className="tab-content" id="myTabContent">
                                <div
                                  className="tab-pane fade show active"
                                  id="all-media"
                                  role="tabpanel"
                                  aria-labelledby="all-media-tab"
                                >
                                  <div className="media-title">
                                    <h3>Media Gallery</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/01.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/04.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/05.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/06.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/07.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/08.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/09.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/10.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/11.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/12.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="album"
                                  role="tabpanel"
                                  aria-labelledby="album-tab"
                                >
                                  <div className="media-title">
                                    <h3>Album Lists</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row g-4">
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/02.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Private</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/03.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Crush</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/06.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Public</h6>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-4 col-sm-6">
                                        <div className="album text-center">
                                          <div className="album-thumb">
                                            <a href="#">
                                              <img
                                                src="assets/images/member/08.jpg"
                                                alt="album"
                                              />
                                            </a>
                                          </div>
                                          <div className="album-content">
                                            <h6>Favorite</h6>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>
                                <div
                                  className="tab-pane fade"
                                  id="photos-media"
                                  role="tabpanel"
                                  aria-labelledby="photos-media-tab"
                                >
                                  <div className="media-title">
                                    <h2>All Photos</h2>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row row-cols-2 row-cols-sm-3 row-cols-md-4 row-cols-lg-5 row-cols-xl-4 g-3">
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/01.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/04.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/05.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/06.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/07.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/08.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/09.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/10.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/11.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/12.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/03.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                      <div className="col">
                                        <div className="media-thumb">
                                          <img
                                            src="assets/images/member/02.jpg"
                                            alt="img"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="video"
                                  role="tabpanel"
                                  aria-labelledby="video-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Videos</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>

                                <div
                                  className="tab-pane fade"
                                  id="music"
                                  role="tabpanel"
                                  aria-labelledby="music-tab"
                                >
                                  <div className="media-title">
                                    <h3>All Music</h3>
                                  </div>
                                  <div className="media-content">
                                    <ul className="media-upload">
                                      <li className="upload-now">
                                        <div className="custom-upload">
                                          <div className="file-btn">
                                            <i className="icofont-upload-alt"></i>
                                            Upload
                                          </div>
                                          <input type="file" />
                                        </div>
                                      </li>
                                    </ul>
                                    <div className="row">
                                      <div className="col">
                                        <p>
                                          <i className="icofont-worried"></i>{" "}
                                          Sorry !! There's no media found for
                                          the request !!{" "}
                                        </p>
                                      </div>
                                    </div>
                                    {hasMore && (
                                    <div className="load-btn text-center my-4 py-3">
                                      <a href="#" className="dating-load-more-btn" onClick={(e) => { e.preventDefault(); getPosts(); }}>Click here for more {loadingMore && <i className="icofont-spinner dating-spinner"></i>}</a>
                                    </div>
                                  )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </article>
                        </div>

                        <div className="col-xl-4">
                          <aside className="mt-5 mt-xl-0">
                            <FilterSearchSection />
                            {/* <WidgetLikeSection /> */}
                            {/* <WidgetGroupSection /> */}
                          </aside>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterSection />

      <CommentModal
        show={showCommentModal}
        onHide={() => setShowCommentModal(false)}
        postId={activeCommentPostId}
      />
    </div>
  );
};

export default GroupPage;
